import { gql } from "@apollo/client";
import { PROMO_DETAIL_FRAGMENT } from "./getPromoDetail";

export const PUT_PROMO_STATUS = gql`
  ${PROMO_DETAIL_FRAGMENT}
  mutation PutPromoStatus($params: PutPromoStatusInput!) {
    putPromoStatus(params: $params) {
      ...PromoDetailFields
    }
  }
`;
